export default __webpack_public_path__ + "static/media/copyIcon.f6678285.svg";